import script from "./TaskListView.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskListView.vue?vue&type=script&setup=true&lang=js"

import "./TaskListView.vue?vue&type=style&index=0&id=9f8ecdf0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f8ecdf0"]])

export default __exports__